var map = {
	"./Amazon.json": [
		590,
		590
	],
	"./BlackOrc.json": [
		513,
		513
	],
	"./Bretonnian.json": [
		900,
		900
	],
	"./ChaosChosen.json": [
		260,
		260
	],
	"./ChaosDwarf.json": [
		438,
		438
	],
	"./ChaosRenegades.json": [
		846,
		846
	],
	"./DarkElf.json": [
		251,
		251
	],
	"./Dwarf.json": [
		497,
		878
	],
	"./ElvenUnion.json": [
		711,
		711
	],
	"./Gnome.json": [
		974,
		974
	],
	"./Goblin.json": [
		781,
		781
	],
	"./Halfling.json": [
		447,
		447
	],
	"./HighElf.json": [
		143,
		143
	],
	"./Human.json": [
		715,
		715
	],
	"./ImperialNobility.json": [
		825,
		825
	],
	"./Khorne.json": [
		65,
		65
	],
	"./Lizardmen.json": [
		346,
		346
	],
	"./NecromanticHorror.json": [
		103,
		103
	],
	"./Norse.json": [
		661,
		661
	],
	"./Nurgle.json": [
		823,
		823
	],
	"./Ogre.json": [
		485,
		485
	],
	"./OldWorldAlliance.json": [
		120,
		120
	],
	"./Orc.json": [
		116,
		116
	],
	"./ShamblingUndead.json": [
		866,
		866
	],
	"./Skaven.json": [
		904
	],
	"./Snotling.json": [
		544,
		544
	],
	"./TombKings.json": [
		16,
		16
	],
	"./UnderworldDenizens.json": [
		0,
		0
	],
	"./Vampire.json": [
		836,
		836
	],
	"./WoodElf.json": [
		100
	],
	"./star_players.json": [
		935
	],
	"./team_tiers.json": [
		341
	],
	"./teams_data.json": [
		849
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 683;
module.exports = webpackAsyncContext;